//500 x 350

export default {
	"nodes": [
	  	{"id": "A", "x": 21, "y": 335},
	  	{"id": "B", "x": 298, "y": 44},
	  	{"id": "C", "x": 91, "y": 95},
		{"id": "D", "x": 479, "y": 184},
	],
	"links": [
		{"source": [21, 335], "target": [298, 44], "value": 6.6, "highlight": true},
        {"source": [21, 335], "target": [91, 95], "value": 5.4, "highlight": true},
        {"source": [21, 335], "target": [479, 184], "value": 4.1, "highlight": false},
        {"source": [298, 44], "target": [91, 95], "value": 1.6, "highlight": false},
        {"source": [298, 44], "target": [479, 184], "value": 3.6, "highlight": true},
        {"source": [91, 95], "target": [479, 184], "value": 3.2, "highlight": true},
	]
  }